export default __webpack_public_path__ + "static/Inter-Bold-b755d2e570b1329b527d5b043973582d.woff";